export default "__VITE_ASSET__ChS9MRwE__"